var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

import styles from './styles.less';

var SortableItem = SortableElement(function (_ref) {
  var className = _ref.className,
      value = _ref.value;
  return React.createElement(
    'div',
    { className: className },
    value
  );
});

var SortableList = SortableContainer(function (_ref2) {
  var className = _ref2.className,
      items = _ref2.items,
      onScroll = _ref2.onScroll,
      inactive = _ref2.inactive;
  return React.createElement(
    'div',
    { className: className, onScroll: onScroll },
    items.map(function (value, index) {
      if (inactive) {
        return React.createElement(
          'div',
          { key: value.props.id, className: styles.sortableItem },
          value
        );
      }
      return React.createElement(SortableItem, {
        key: value.props.id,
        className: styles.sortableItem,
        index: index,
        value: value
      });
    })
  );
});

var Draggable = function (_Component) {
  _inherits(Draggable, _Component);

  function Draggable(props) {
    _classCallCheck(this, Draggable);

    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

    _this.onSortEnd = function (_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;
      var setAnswer = _this.context.setAnswer;

      var newItemsOrder = arrayMove(_this.state.items, oldIndex, newIndex);
      _this.setState({
        items: newItemsOrder
      });
      setAnswer(newItemsOrder.map(function (i) {
        return i.props.id;
      }));
    };

    _this.onScroll = function (e) {
      var setScrollPosition = _this.props.setScrollPosition;

      setScrollPosition(e.currentTarget.scrollTop);
    };

    _this.state = {
      items: props.children
    };
    return _this;
  }

  _createClass(Draggable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var children = this.props.children;

      if (nextContext.enteredAnswer === null && children[0].key !== nextProps.children[0].key) {
        this.$sortableList.scrollContainer.scrollTop = 0;
        this.setState({
          items: nextProps.children
        });
      } else {
        this.$sortableList.scrollContainer.scrollTop = nextProps.scrollPos;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inactive = _props.inactive,
          showScroll = _props.showScroll;
      var items = this.state.items;

      return React.createElement(SortableList, {
        className: styles.sortableList + ' ' + (showScroll ? styles.sortableOverflow : null),
        ref: function ref(sList) {
          _this2.$sortableList = sList;
        },
        items: items,
        onScroll: this.onScroll,
        onSortEnd: this.onSortEnd,
        lockAxis: 'y',
        distance: 5 // sortable after being dragged a certain number of pixels, so click events won't be swallowed
        , inactive: inactive
      });
    }
  }]);

  return Draggable;
}(Component);

export default Draggable;


Draggable.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  showScroll: PropTypes.bool,
  scrollPos: PropTypes.number,
  setScrollPosition: PropTypes.func,
  inactive: PropTypes.bool
} : {};

Draggable.defaultProps = {
  children: null,
  showScroll: false,
  scrollPos: 0,
  inactive: false,
  setScrollPosition: function setScrollPosition() {}
};

Draggable.contextTypes = {
  setAnswer: PropTypes.func,
  enteredAnswer: PropTypes.arrayOf(PropTypes.number)
};